document.addEventListener('DOMContentLoaded', function() {
  const collectionLinks = document.querySelectorAll('a[href*="/collections/"]');
  collectionLinks.forEach(link => {
    const href = link.getAttribute('href');
    if (href.includes('/collections/polo-neck-tees')) {
      link.addEventListener('click', function(event) {
        event.preventDefault();
        window.location.href = '/products/polo-neck-black-tees';
      });
    } else if (href.includes('/collections/tees')) {
      link.addEventListener('click', function(event) {
        event.preventDefault();
        window.location.href = '/products/kala-ghoda-tees';
      });
    } else if (href.includes('/collections/shorts')) {
      link.addEventListener('click', function(event) {
        event.preventDefault();
        window.location.href = '/products/black-shorts';
      });
    }
  });
});